import * as React from 'react';
import { Container } from '../../Components/Container';
import { Text } from '@fluentui/react';
import { ConsumerCard } from './ConsumerCard';
import { DataOwnerCard } from './DataOwnerCard';
import { UserPortalsCardList } from '../../Common/Styles/homeCards.styled';
import { OtherPortalsCardList } from '../../Common/Styles/otherPortals.styled';
import { AnnouncementsCard, DocumentationCard, SupportChannelCard } from './OtherPortalsCards';

export function Home(): React.ReactElement {
  return (
    <Container>
      <title>Home Page</title>

      <HomeHeadingContainer>
        <HomeHeadingTextStyled>User Portals</HomeHeadingTextStyled>
      </HomeHeadingContainer>

      <UserPortalsCardList>
        <ConsumerCard />
        <DataOwnerCard />
      </UserPortalsCardList>

      <HomeHeadingContainer>
        <HomeHeadingTextStyled>Other Portals</HomeHeadingTextStyled>
      </HomeHeadingContainer>

      <OtherPortalsCardList>
        <DocumentationCard />
        <SupportChannelCard />
        <AnnouncementsCard />
      </OtherPortalsCardList>
    </Container>
  );
}

const HomeHeadingContainer = styled.div`
  padding-top: 64px;
  padding-bottom: 32px;
`;

const HomeHeadingTextStyled = styled(Text)`
  font-weight: 800;
  font-size: 26px;
  line-height: 30px;
  color: #171717;
`;
